<template>
  <el-button
    @click="$emit('click', $event)"
    :icon="icon"
    :type="type"
    :size="size"
    :loading="loading"
    :title="title ? title : label"
    :disabled="disabled"
  >
    <span class="d-none d-sm-inline d-xl-inline">
      <i v-if="icon" :class="$utilidade.getIcone(icon)"/> {{ label }}
    </span>
  </el-button>
</template>

<script>
import EdFormMixin from "./mixins/formControl";

export default {
  name: "EdButton",
  mixins: [EdFormMixin],
  props: {
    text: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: [Boolean, String],
      required: false,
      default: null,
    },
    type: {
      type: String,
      default: function () {
        return "primary";
      },
    },
    size: {
      type: String,
      default: function () {
        return "medium";
      },
    },
  },
  data() {
    return {};
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>



// WEBPACK FOOTER //
// EdButton.vue?89b45798